const classwiseTest = {
  0: [],
  9: [3, 5],
  10: [1, 3, 4],
  11: [1, 2, 3, 4, 5],
  12: [1, 2, 3, 4, 5, 6, 7],
}

export default classwiseTest
